import styled from 'styled-components'
import { Link as LinkStyles } from '@chegg-wt/core/theme/sunkist/link'
import {
  Heading2,
  BodyLargeBold,
  BodyGray,
} from '@chegg-wt/core/theme/sunkist/typography'

export const Container = styled.div.attrs({
  role: 'region',
  'aria-label': 'Learn More',
})`
  padding: 0 32px;
  max-width: 900px;
  margin: 0 auto;
`

export const Link = styled.a`
  ${LinkStyles};
`

export const HeadingContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.lg};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`

export const ContentHeading = styled.h2`
  margin: 0;
  text-align: center;
  ${Heading2};
`

export const Header = styled.h3`
  margin: 0;
  margin-bottom: 4px;
  ${BodyLargeBold};
`

export const Body = styled.div`
  margin-bottom: 24px;
  ${BodyGray};
`
